var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationPreventativeMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 76,
    rx: 38,
    fill: "#FBC02D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4734 46.9286L33.8104 14.5009H44.0654L42.3331 46.9286H35.4734ZM38.9379 63.4889C37.3211 63.4889 35.9815 62.9577 34.9191 61.8953C33.8566 60.8328 33.3254 59.5625 33.3254 58.0843C33.3254 56.6061 33.8566 55.3589 34.9191 54.3427C35.9815 53.2802 37.3211 52.749 38.9379 52.749C40.5547 52.749 41.8712 53.2802 42.8874 54.3427C43.9037 55.3589 44.4118 56.6061 44.4118 58.0843C44.4118 59.5625 43.9037 60.8328 42.8874 61.8953C41.8712 62.9577 40.5547 63.4889 38.9379 63.4889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPreventativeMaintenance);
export default __webpack_public_path__ + "static/media/exclamationPreventativeMaintenance.381dd95ba0b63e79ba1b85f03f0fddca.svg";
export { ForwardRef as ReactComponent };